import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

export const walletSlice = createSlice({
  name: 'walletReducer',
  initialState,
  reducers: {
    setReduxWallet: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});

export const { setReduxWallet } = walletSlice.actions;

export default walletSlice.reducer;
